import { render } from "./TagItem.vue?vue&type=template&id=2705d1c3"
const script = {}

import "./TagItem.vue?vue&type=style&index=0&id=2705d1c3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__